import {
  includesAny,
  toNormalizedMessage,
} from '@/shared/utils/sentry/clientIgnoreRules/stringMatchers';
import { ClientSentryIgnoreRule } from '@/shared/utils/sentry/clientIgnoreRules/types';

const EXPECTED_ROUTE_CANCEL_MESSAGE_PARTS = [
  'loading initial props cancelled',
  'abort fetching component for route',
  'cancel rendering route',
] as const;

const isExpectedRouteCancelMessage = (message: unknown): boolean => {
  const normalizedMessage = toNormalizedMessage(message);
  if (!normalizedMessage) {
    return false;
  }

  return includesAny(normalizedMessage, EXPECTED_ROUTE_CANCEL_MESSAGE_PARTS);
};

export const nextRouteCancellationRule: ClientSentryIgnoreRule = {
  id: 'next-route-cancellation',
  references: ['SUPTF-1921', 'FTR-2531'],
  reason: 'Expected Next.js route cancellation noise during client navigation',
  matches: ({ originalExceptionMessage, serializedMessage }) =>
    isExpectedRouteCancelMessage(originalExceptionMessage) ||
    isExpectedRouteCancelMessage(serializedMessage),
};
